export const ALL = "all";
export const ADMIN = "admin";
export const INTERN = "intern";
export const MENTOR = "mentor";
export const ANONYMOUS = "anonymous";
